import { render, staticRenderFns } from "./SyntheticMediaStyleReference.vue?vue&type=template&id=5a2486e5&scoped=true"
import script from "./SyntheticMediaStyleReference.vue?vue&type=script&lang=js"
export * from "./SyntheticMediaStyleReference.vue?vue&type=script&lang=js"
import style0 from "./SyntheticMediaStyleReference.vue?vue&type=style&index=0&id=5a2486e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2486e5",
  null
  
)

export default component.exports